import { render, staticRenderFns } from "./IntegrationSettingsPage.vue?vue&type=template&id=bd61c9e6&scoped=true"
import script from "./IntegrationSettingsPage.vue?vue&type=script&lang=js"
export * from "./IntegrationSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./IntegrationSettingsPage.vue?vue&type=style&index=0&id=bd61c9e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd61c9e6",
  null
  
)

export default component.exports